// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px !important;
  background: white !important;
  border-top: 1px solid #e6e6e6;
}
.ant-layout-footer .copyright {
  font-size: 12px;
  margin-bottom: 12px;
}
@media (min-width: 768px) {
  .ant-layout-footer {
    flex-direction: row;
  }
  .ant-layout-footer .copyright {
    margin-right: auto;
    margin-bottom: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+studio-tools@1.9.9_@types+react@18.3.12_antd@5.24.6_date-fns@2.30.0_moment@2.30.1_rea_phmwef3nwavhog6egt6kd254om/node_modules/@nackle/studio-tools/dist/components/app-footer/app-footer.less"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;AAAJ;AANA;EASQ,eAAA;EACA,mBAAA;AAAR;AAGI;EAAA;IACI,mBAAA;EAAN;EADE;IAIQ,kBAAA;IACA,oBAAA;EAAV;AACF","sourcesContent":["\n.ant-layout-footer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 24px !important;\n    background: white !important;\n    border-top: 1px solid rgb( 230, 230, 230 );\n\n    .copyright {\n        font-size: 12px;\n        margin-bottom: 12px;\n    }\n\n    @media (min-width: 768px) {\n        flex-direction: row;\n\n        .copyright {\n            margin-right: auto;\n            margin-bottom: unset;\n        }\n    }\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
